import React, { useEffect, useMemo, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { Modal } from "antd";
import { ContentState, EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import CloseIcon from "@mui/icons-material/Close";

import emailEditor from "../../../../common/EmailEditor";
import styles from "../../../SwmsMasters/SwmsMastersStyle.module.css";

const getEditorStateFromHtml = (html) => {
  const htmlValue = html ? `${html}` : "";

  if (!htmlValue) {
    return EditorState.createEmpty();
  }

  const parsedHtml = htmlToDraft(htmlValue);
  if (parsedHtml && parsedHtml.contentBlocks) {
    const contentState = ContentState.createFromBlockArray(parsedHtml.contentBlocks);
    return EditorState.createWithContent(contentState);
  }

  return EditorState.createEmpty();
};

const getNormalizedHeadingHtml = (editorState) => {
  if (!editorState || !editorState.getCurrentContent().hasText()) {
    return "";
  }

  return draftToHtml(convertToRaw(editorState.getCurrentContent()));
};

let PreStartHeadingEditorModal = ({
  headingLabel,
  initialValues,
  handleSubmit,
  pristine,
  change,
  onClose,
  onSave
}) => {
  const defaultEditorState = useMemo(() => {
    const headingContent = initialValues && initialValues.heading_content ? initialValues.heading_content : "";
    return getEditorStateFromHtml(headingContent);
  }, [initialValues]);

  const [editorState, setEditorState] = useState(defaultEditorState);

  useEffect(() => {
    setEditorState(defaultEditorState);
  }, [defaultEditorState]);

  const onEditorStateChange = (nextState) => {
    setEditorState(nextState);
    change("heading_content", getNormalizedHeadingHtml(nextState));
  };

  const onSubmit = () => {
    if (onSave) {
      onSave(getNormalizedHeadingHtml(editorState));
    }
  };

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible
      onCancel={onClose}
      destroyOnClose
      maskClosable={false}
      width={900}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      getContainer={() => document.body}
      closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      <div className="v2-modal-container">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className={styles.ModalHeading}>{`Edit ${headingLabel}`}</div>
                <hr />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-12">
                <div className={styles.Label}>Heading Content</div>
                <div className="swmsv2-custom-draft-editor">
                  <Field
                    name="heading_content"
                    component={emailEditor}
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange}
                    otherProps={{
                      editorStyle: {
                        padding: "0px 4px",
                        minHeight: "180px"
                      }
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 pt-3 text-right">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "end", columnGap: "10px" }}>
                  <button
                    type="button"
                    className={styles.OutlinedButton}
                    onClick={onClose}
                    style={{ padding: "0px 5px" }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className={styles.PrimaryButton}
                    disabled={pristine}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

PreStartHeadingEditorModal = reduxForm({
  form: "pre_start_heading_editor_modal",
  destroyOnUnmount: true,
  enableReinitialize: true
})(PreStartHeadingEditorModal);

export default PreStartHeadingEditorModal;
